import { Card, Col, Table } from "react-bootstrap";
import React from "react";

import { useTranslation } from "react-i18next";

function TableSalesTable({ regionName, data }) {
  const {
    t,
  } = useTranslation();

  const totalQuantity = data.reduce((acc, row) => acc + parseInt(row.count), 0);
  const totalSum = data.reduce((acc, row) => acc + parseFloat(row.total), 0);
  const totalPeople = data.reduce((acc, row) => acc + parseFloat(row.people), 0);

  return (
    <Card className="strpied-tabled-with-hover">
      <Card.Header>
        <Col>
          <Card.Title as="h4">{`${regionName}`}</Card.Title>
        </Col>
      </Card.Header>
      <Card.Body className="table-responsive p-0">
        <Table className="table-hover" style={{ tableLayout: "fixed" }}>
          <thead>
            <tr>
              <th>{t("tables.headers.name")}</th>
              <th>{t("tables.headers.tables")}</th>
              <th>{t("tables.headers.people")}</th>
              <th>{t("tables.headers.totalEuro")}</th>
            </tr>
          </thead>
          <tbody>
            {_.orderBy(data, "total", "desc").map((row) => (
              <tr key={row.id}>
                <td>{row.tableName}</td>
                <td>{row.count}</td>
                <td>{row.people}</td>
                <td>{row.total.toFixed(2)}</td>
              </tr>
            ))}
            <tr key="total">
              <td>
                <strong>{regionName}</strong>
              </td>
              <td>
                <strong>{totalQuantity}</strong>
              </td>
              <td>
                <strong>{totalPeople}</strong>
              </td>
              <td>
                <strong>{totalSum.toFixed(2)}</strong>
              </td>
            </tr>
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}

export default TableSalesTable;
